export interface GroupableMessage {
	role: "USER" | "ASSISTANT"
}

// Mirrors groupEventsBySender in the inbox timeline: consecutive messages from
// the same side sit closer together than the gap between two speakers.
export const groupConsecutiveMessages = <T extends GroupableMessage>(
	messages: T[],
): T[][] => {
	const groups: T[][] = []

	for (const message of messages) {
		const current = groups[groups.length - 1]
		if (current && current[0]?.role === message.role) {
			current.push(message)
			continue
		}
		groups.push([message])
	}

	return groups
}

// The tooltip in a message header names where it came from, so the column feed
// carries the thread's own channel instead of assuming live chat.
export const conversationMessageSource = (
	origin: string | null,
): "email" | "slack" | "teams" | "live-chat" | "widget" | null => {
	switch (origin) {
		case "EMAIL":
			return "email"
		case "SLACK":
		case "SLACK_CONNECT":
			return "slack"
		case "WIDGET":
			return "widget"
		case "LIVE_CHAT":
		case "AI_CHAT":
			return "live-chat"
		default:
			return null
	}
}
